import { render, staticRenderFns } from "./createFranchiseNurse.vue?vue&type=template&id=0a78b1d8&scoped=true&"
import script from "./createFranchiseNurse.vue?vue&type=script&lang=js&"
export * from "./createFranchiseNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78b1d8",
  null
  
)

export default component.exports